import { render } from "./UsersListPage.vue?vue&type=template&id=667ac33c&ts=true"
import script from "./UsersListPage.vue?vue&type=script&lang=ts"
export * from "./UsersListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__